import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { CONTACT, LEGAL, BRAND } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="navy-texture text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt="Logo DS EXPERT"
                className="h-12 w-12 object-contain bg-white rounded-sm p-1"
              />
              <span className="font-serif-display text-2xl font-bold tracking-tight">
                DS EXPERT
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-slate-300 max-w-sm">
              {t.company.tagline}. {t.footer.blurb}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-[#C9A15A]">
              {t.footer.navTitle}
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li>
                <Link
                  to="/"
                  data-testid="footer-home-link"
                  className="hover:text-[#C9A15A] transition-colors"
                >
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link
                  to="/a-propos"
                  data-testid="footer-about-link"
                  className="hover:text-[#C9A15A] transition-colors"
                >
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  data-testid="footer-services-link"
                  className="hover:text-[#C9A15A] transition-colors"
                >
                  {t.nav.services}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-contact-link"
                  className="hover:text-[#C9A15A] transition-colors"
                >
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-[#C9A15A]">
              {t.footer.contactTitle}
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#C9A15A] shrink-0 mt-0.5" />
                <span>{CONTACT.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#C9A15A] shrink-0" />
                <a
                  href={`tel:${CONTACT.phoneHref}`}
                  className="hover:text-[#C9A15A] transition-colors"
                >
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#C9A15A] shrink-0" />
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-[#C9A15A] transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} {BRAND.fullName}. {t.footer.rights}
          </p>
          <p className="text-xs text-slate-400">
            RCCM {LEGAL.rccm} · NINEA {LEGAL.ninea} · {t.about.legalLabels.capital}{" "}
            {LEGAL.capital} · Dakar — Sénégal
          </p>
        </div>
      </div>
    </footer>
  );
}
